import { render, staticRenderFns } from "./SchoolEdit.vue?vue&type=template&id=f74d2bde"
import script from "./SchoolEdit.vue?vue&type=script&lang=ts"
export * from "./SchoolEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports